
import { useState, useEffect, useContext, createContext } from "react";

export {
  ProductsContextProvider,
  useProducts, useProductsUpdate
};


// TODO: --------- RENAME TO Purchase Context ?? I.e. all on Purchase Page is here (??)


const ProductsContext = createContext<Products>({ products: [], selectedProducts:[] });
const ProductsUpdateContext = createContext<UpdateProduct>({
  // TODO: Find better way? These shouldn't be used since using Context Provider
  // -- Could do Tyhpe of "UpdateProduct | undefined" and pass in "undefined" here...
  // ---- BUT, this causes Linter Type issues when use this. Eg. "no type addProduct on undefined" (soimething like that)
  addProduct: (product) => {},
  removeProduct: (product) => {}
});

function useProducts() {
  return useContext( ProductsContext );
}

function useProductsUpdate() {
  return useContext( ProductsUpdateContext );
}


type AddProduct = ( product: IProduct ) => void;
type RemoveProduct = ( product: IProduct ) => void;
type UpdateProduct = { addProduct: AddProduct, removeProduct: RemoveProduct };

type Products = { products: IProduct[], selectedProducts: IProduct[] };

function ProductsContextProvider( {children}: ComponentProps ) {
  // Provider handles...

  // ... Creating State
  const [selectedProducts, setSelectedProducts] = useState<IProduct[]>( [] );
  const [products, setProducts] = useState<IProduct[]>( [] );

  // TODO: Fetch Products Data
  useEffect( () => {
    const mockProducts = require("../data/mock-products.json"); // TODO: CHANGE FOR SERVER

    setProducts( mockProducts );
  }, []);


  // ... Updating State
  function addProduct( product: IProduct ) {
    if( product == null ) return;
    // TODO: Don't add if Product already added...
    // -------------------- Consider a Unique ID to check or something? Just check if name alread in list?
    // TODO: Save/Backup to LocalStorage, cuz currently HARD RELOAD removes all (See Shopping Cart examples w/ React and TS - WebDevSimplified)
    // TODO: Add to LocalStorage or sync to Server for User's "Shopping Cart" -- Hard Reload Removes first
    selectedProducts.push( product );
    setSelectedProducts( [...selectedProducts] ); //  Need see new Obj/Array for ReRender to occur
  };

  function removeProduct( productToDelete: IProduct ) {
    if( productToDelete == null ) return;

    setSelectedProducts( selectedProducts.filter( product => {
      return product.name != productToDelete.name;
    }) );
  }

  // ... Persisting State down into Children
  return (
    <ProductsContext.Provider value={ {products, selectedProducts} } >
      <ProductsUpdateContext.Provider value={ {addProduct, removeProduct} } >
        {children}
      </ProductsUpdateContext.Provider>
    </ProductsContext.Provider>
  );
}
